import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import RippleLoader from "../../../components/loader/RippleLoader";
import { Form, Formik } from "formik";
import ConfirmationModel from "../../../components/common/ConfirmationModel";
import {
  DeleteSales,
  createSalesPerson,
  getCompanies,
  getSalesPersonList,
} from "../../../redux/companies/slice";
import { useDispatch, useSelector } from "react-redux";
import { DeleteIcon, Plus } from "../../../assets/svg";
import { SelectWithLabel } from "../../../components/micro/input";

const AddEditSales = ({ onClose, companyId, salesPersonData }) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [formValues, setFormValues] = useState(null);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [salesPersonDatas, setSalesPersonDatas] = useState(
    salesPersonData || []
  );
  const isEditMode = salesPersonData?.length > 0;

  //Selector
  const { salesPersonList } = useSelector((store) => ({
    salesPersonList: store?.companiesData?.getSalesPersonListStatus?.data,
  }));

  useEffect(() => {
    dispatch(getSalesPersonList({ search: "", limit: "all" }));
  }, []);

  const salesPerson = salesPersonList?.data?.map((salesPerson) => ({
    label: salesPerson?.full_name,
    value: salesPerson?.id,
  }));

  const handleFormSubmit = async (values) => {
    if (!Array.isArray(values.salesPerson)) {
      console.error(
        "Expected values.salesPerson to be an array",
        values.salesPerson
      );
      return;
    }
    const payload = {
      sales_person: values.salesPerson.map((person, index) => ({
        ...(salesPersonData?.length && salesPersonData[index]?.id
          ? { id: salesPersonData[index]?.id }
          : {}),
        company_id: companyId,
        sales_person_id: person?.value,
      })),
    };
    setIsLoading(true);
    dispatch(createSalesPerson(payload))
      .then((res) => {
        if (res.type === "createSalesPerson/fulfilled") {
          onClose();
          dispatch(getCompanies({ id: companyId }));
        }
        setShowConfirmationModal(false);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const handleRemoveSalesPerson = async (
    indexToRemove,
    formikValues,
    setFormikFieldValue,
    personID
  ) => {
    const person = formikValues.salesPerson[indexToRemove];
    const isPersonEmpty =
      person?.value === undefined && person?.label === undefined;

    if (!isPersonEmpty && personID) {
      try {
        setIsLoading(true);
        const res = await dispatch(DeleteSales(personID));
        if (res.type === "DeleteSales/fulfilled") {
          const updatedSalesPersonDatas = salesPersonDatas.filter(
            (_, index) => index !== indexToRemove
          );
          const updatedSalesPerson = formikValues.salesPerson.filter(
            (_, index) => index !== indexToRemove
          );

          setSalesPersonDatas(updatedSalesPersonDatas);
          setFormikFieldValue("salesPerson", updatedSalesPerson);

          await dispatch(getCompanies({ id: companyId }));
        }
      } finally {
        setIsLoading(false);
      }
    } else {
      const updatedSalesPersonDatas = salesPersonDatas.filter(
        (_, index) => index !== indexToRemove
      );
      const updatedSalesPerson = formikValues.salesPerson.filter(
        (_, index) => index !== indexToRemove
      );

      setSalesPersonDatas(updatedSalesPersonDatas);
      setFormikFieldValue("salesPerson", updatedSalesPerson);
    }
  };

  const initialValues = {
    salesPerson: salesPersonDatas?.map((person) => ({
      value: person?.user_id,
      label: person?.user?.full_name,
    })),
  };

  const handleAddSalesPerson = (setFormikFieldValue, formikValues) => {
    const updatedData = [
      ...salesPersonDatas,
      { id: Date.now(), value: null, label: null },
    ];

    const updatedFormikValues = [
      ...formikValues.salesPerson,
      { value: undefined, label: undefined },
    ];

    setSalesPersonDatas(updatedData);
    setFormikFieldValue("salesPerson", updatedFormikValues);
  };

  return (
    <>
      <div className="model" onClick={onClose} style={{ zIndex: 1300 }}>
        <div
          className="bg-white items-center justify-center drop-shadow-lg rounded-lg w-full max-w-xl py-8 px-6 mx-auto relative"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <h4 className="font-Montserrat text-[34px] font-normal">
            {isEditMode ? "Edit Sales Person" : "Add Sales Person"}
          </h4>
          {isLoading ? (
            <RippleLoader />
          ) : (
            <Formik
              initialValues={initialValues}
              validationSchema={Yup.object().shape({
                salesPerson: Yup.array()
                  .min(1, "sales person is required")
                  .of(
                    Yup.object().shape({
                      value: Yup.string()
                        .required("Sales person is required")
                        .nullable(),
                      label: Yup.string().required(
                        "Sales person label is required"
                      ),
                    })
                  ),
              })}
              onSubmit={(values) => {
                setFormValues(values);
              }}
            >
              {({
                values,
                handleSubmit,
                setFieldValue,
                errors,
                touched,
                validateForm,
                setFieldTouched,
              }) => (
                <Form onSubmit={handleSubmit}>
                  {salesPersonData?.length > 0 ? (
                    <>
                      <div className=" mt-3">
                        <>
                          {salesPersonDatas?.map((person, index) => (
                            <>
                              <div
                                key={person.id}
                                className="flex justify-between items-center gap-8"
                              >
                                <div className="flex-grow mb-4 ">
                                  <SelectWithLabel
                                    idFromName={`salesPerson-${index}`}
                                    placeholder="Select Sales Person"
                                    options={salesPerson}
                                    value={
                                      values?.salesPerson[index]?.value || {
                                        value: "",
                                        label: "",
                                      }
                                    }
                                    setFieldValue={setFieldValue}
                                    errors={errors.salesPerson?.[index]?.value}
                                    touched={
                                      touched.salesPerson?.[index]?.value
                                    }
                                    onChange={(event) => {
                                      const selectedOption = salesPerson.find(
                                        (option) =>
                                          option.value === event.target.value
                                      );

                                      setFieldValue(
                                        `salesPerson[${index}]`,
                                        selectedOption
                                      );
                                    }}
                                    MenuProps={{
                                      PaperProps: {
                                        sx: {
                                          zIndex: 1301,
                                          maxHeight: "300px",
                                          overflowY: "auto",
                                        },
                                      },
                                    }}
                                  />
                                </div>
                                <div className="pb-3">
                                  <button
                                    onClick={() => {
                                      handleRemoveSalesPerson(
                                        index,
                                        values,
                                        setFieldValue,
                                        person?.id
                                      );
                                    }}
                                  >
                                    <DeleteIcon />
                                  </button>
                                </div>
                              </div>
                            </>
                          ))}
                        </>
                      </div>
                      <div className="flex justify-center">
                        <button
                          type="button"
                          className="flex text-themeBtn items-center gap-1"
                          onClick={() =>
                            handleAddSalesPerson(setFieldValue, values)
                          }
                        >
                          <Plus fill="#F15B29" /> ADD
                        </button>
                      </div>
                    </>
                  ) : (
                    <div className="mb-4 mt-3">
                      <SelectWithLabel
                        idFromName="salesPerson"
                        placeholder="Select Sales Person"
                        options={salesPerson}
                        value={values?.salesPerson?.value}
                        setFieldValue={setFieldValue}
                        errors={errors.salesPerson}
                        touched={touched.salesPerson}
                        onChange={(event) => {
                          const selectedOption = salesPerson?.find(
                            (option) => option.value === event.target.value
                          );
                          setFieldValue("salesPerson", [selectedOption]);
                        }}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              zIndex: 1301,
                              maxHeight: "300px",
                              overflowY: "auto",
                            },
                          },
                        }}
                      />
                    </div>
                  )}
                  {/* Submit button */}
                  <div className="flex justify-end gap-3 mt-3 w-full">
                    <button
                      onClick={onClose}
                      type="button"
                      className=" text-themeBtn w-full flex items-center uppercase font-Montserrat justify-center px-6 py-1.5 rounded border border-themeBtn"
                    >
                      <span>Cancel</span>
                    </button>
                    <button
                      type="button"
                      onClick={async () => {
                        const errors = await validateForm();

                        values.salesPerson.forEach((_, index) => {
                          setFieldTouched(
                            `salesPerson[${index}].value`,
                            true,
                            true
                          );
                          setFieldTouched(
                            `salesPerson[${index}].label`,
                            true,
                            true
                          );
                        });

                        const isValid = Object.keys(errors).length === 0;

                        if (isValid) {
                          setFormValues(values);
                          setShowConfirmationModal(true);
                        }
                      }}
                      className={`${
                        values?.salesPerson?.length === 0
                          ? "cursor-not-allowed bg-borderLine text-textSecondary"
                          : "bg-themeBtn text-white"
                      } flex items-center w-full justify-center px-6 py-1.5 rounded font-Montserrat uppercase`}
                    >
                      <span>Confirm</span>
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          )}
        </div>

        {/* Confirmation modals */}
        {showConfirmationModal && (
          <ConfirmationModel
            confirmText={isEditMode ? "Edit" : "Create"}
            onClose={() => setShowConfirmationModal(false)}
            onConfirm={() => handleFormSubmit(formValues)}
            isLoading={isLoading}
          />
        )}
      </div>
    </>
  );
};

export default AddEditSales;
